import { Artist, Instrument, ModelNoDates } from "@/types/types";
import { getArtist } from "@/utils/artistInstrumentModelMixedModel/get/getArtist";
import { getInstrument } from "@/utils/artistInstrumentModelMixedModel/get/getInstrument";
import { getModel } from "@/utils/artistInstrumentModelMixedModel/get/getModel";

export const getArtistInstrumentModel = (
  id: string,
  models: ModelNoDates[] | null
): Artist | Instrument | ModelNoDates | null => {
  // Check if the id is an artist
  const foundArtist = getArtist(id);
  if (foundArtist !== null) {
    return foundArtist;
  }

  // Check if the id is an instrument
  const foundInstrument = getInstrument(id);
  if (foundInstrument !== null) {
    return foundInstrument;
  }

  // Check if the id is a model
  if (models !== null) {
    const foundModel = getModel(id, models);

    if (foundModel !== null) {
      return foundModel;
    }
  }

  // If the id is not found return null
  return null;
};
